import React, { useEffect, useState } from "react";
import ReconForm from "./components/ReconForm";
import TransactionList from "./components/TransactionList";
import { getReconcilationTimeTxn } from "../../config/LiveApi";
import SelectedTransactions from "./components/SelectedTransactions";
import { useSelector } from "react-redux";

function Reconciliation() {
  let token = useSelector(store => store.userReducer.token);
  const role = useSelector(store => store.userReducer.role);
  const [showZyroList, setShowZyroList] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [addedDataForRecon, setAddedDataForRecon] = useState([]);
  const [showOurList, setShowOurList] = useState(false);
  const [initialFetchDone, setInitialFetchDone] = useState(false);

  // Function to fetch transaction details by UTR
  const reconTxn = async (token, utr) => {
    try {
      const txnData = await getReconcilationTimeTxn(token, { utr });
      return txnData;
    } catch (error) {
      console.error("Error fetching reconciliation data:", error);
      return [];
    }
  };

  useEffect(() => {
    const fetchTransactionDetails = async () => {
      if (excelData.length > 0 && !isDataFetched && !initialFetchDone) {
        setInitialFetchDone(true); // Set to true to prevent re-fetching
        for (const item of excelData) {
          const utr = item.RRN; // Extract the UTR (RRN in your case)

          if (!utr) {
            console.error("No RRN found for item:", item);
            setExcelData((prevData) => [
              ...prevData,
              { ...item, transactionDetails: [] },
            ]);
            continue;
          }

          let data = await reconTxn(token, utr);

          if (data && Array.isArray(data.total_payin_transactions)) {
            item.transactionDetails = data.total_payin_transactions;
          } else {
            console.error(
              "No valid total_payin_transactions returned for item:",
              item
            );
            item.transactionDetails = []; // Set to empty if no valid data
          }

          // Update state immediately after fetching data for the item
          setExcelData((prevData) => {
            const existingItemIndex = prevData.findIndex(
              (i) => i.RRN === item.RRN
            );
            if (existingItemIndex > -1) {
              // If item exists, replace it
              const updatedData = [...prevData];
              updatedData[existingItemIndex] = { ...item };
              return updatedData;
            }
            // If it doesn't exist, add it
            return [...prevData, { ...item }];
          });
        }

        setIsDataFetched(true);
      }
    };

    fetchTransactionDetails();
  }, [isDataFetched, token, excelData, initialFetchDone]);

  return (
    <div>
      {showOurList ? (
        <SelectedTransactions addedDataForRecon={addedDataForRecon} />
      ) : showZyroList ? (
        <TransactionList
          excelData={excelData}
          setAddedDataForRecon={setAddedDataForRecon}
          addedDataForRecon={addedDataForRecon}
          setShowZyroList={setShowZyroList}
          setShowOurList={setShowOurList}
        />
      ) : (
        <ReconForm
          setShowZyroList={setShowZyroList}
          setExcelData={setExcelData}
          setShowOurList={setShowOurList}
          setAddedDataForRecon={setAddedDataForRecon}
        />
      )}
    </div>
  );
}

export default Reconciliation;
